<mat-drawer-container id="drawer_container" class="custom-drawer-container" autosize>
  <mat-drawer
    class="{{ expanded() ? 'fat-drawer' : 'smaller-drawer' }} common-drawer"
    id="drawer"
    mode="side"
    opened="true">
    <button mat-button id="expand_button" class="expansion-button" (click)="resize()">
      <i id="bars_icon" class="fas fa-bars icon"></i>
    </button>

    <div id="custom_drawer_content" class="custom-drawer-content">
      <img
        class="side-nav-logo {{ expanded() ? '' : 'invisible' }}"
        id="acetech_image"
        src="/assets/images/acetech_logo_white.png"
        alt="Logo"
        title="Logo" />

      @if ([accessRight.Customers] | anyRights) {
        <div
          class="{{ expanded() ? 'nav-list-active' : '' }} nav-list-item"
          id="customer_list_item"
          mat-list-item
          routerLink="/customers"
          routerLinkActive="active-list-item"
          matTooltipPosition="right"
          [matTooltip]="!expanded() ? 'Customers' : null"
          [matTooltipShowDelay]="500">
          <span class="list-icon"><i id="cus_icon" class="fas fa-user icon list-icon"></i></span>
          @if (expanded()) {
            <span id="cus_text" class="nav-list-text">Customers</span>
          }
        </div>
      }

      @if ([accessRight.Integrations] | anyRights) {
        <div
          class="{{ expanded() ? 'nav-list-active' : '' }} nav-list-item"
          id="integrations_list_item"
          mat-list-item
          routerLinkActive="active-list-item"
          matTooltipPosition="right"
          routerLink="/integrations"
          [routerLinkActiveOptions]="{ exact: false }"
          [matTooltip]="!expanded() ? 'Integrations' : null"
          [matTooltipShowDelay]="500">
          <span class="list-icon"><i id="cad_icon" class="fas fa-sitemap icon list-icon"></i></span>
          @if (expanded()) {
            <span id="integrations_text" class="nav-list-text">Integrations</span>
          }
        </div>
      }

      @if ([accessRight.Managers] | anyRights) {
        <div
          class="{{ expanded() ? 'nav-list-active' : '' }} nav-list-item"
          id="manager_list_item"
          mat-list-item
          routerLink="/managers"
          routerLinkActive="active-list-item"
          matTooltipPosition="right"
          [matTooltip]="!expanded() ? 'Account Managers' : null"
          [matTooltipShowDelay]="500">
          <span class="list-icon"
            ><i id="manager_icon" class="fas fa-users icon list-icon"></i
          ></span>
          @if (expanded()) {
            <span id="manager_text" class="nav-list-text">Acc. Managers</span>
          }
        </div>
      }

      @if ([accessRight.ProductAdmin] | anyRights) {
        <div
          class="{{ expanded() ? 'nav-list-active' : '' }} nav-list-item"
          id="release_notes_list_item"
          mat-list-item
          routerLink="/release-notes"
          routerLinkActive="active-list-item"
          matTooltipPosition="right"
          [matTooltip]="!expanded() ? 'Release Notes' : null"
          [matTooltipShowDelay]="500">
          <span class="list-icon"><i id="pen_icon" class="fas fa-pen icon list-icon"></i></span>
          @if (expanded()) {
            <span id="release_notes_text" class="nav-list-text">Release Notes</span>
          }
        </div>
      }

      <hr id="logout_hr" class="custom-hr" />

      <div
        class="{{ expanded() ? 'nav-list-active' : '' }} nav-list-item"
        id="logout_list_item"
        mat-list-item
        matTooltip="Logout"
        matTooltipPosition="right"
        [matTooltipShowDelay]="500"
        (click)="logout()">
        <span class="list-logout"
          ><i id="logout_icon" class="fas fa-sign-out-alt icon list-icon"></i
        ></span>
        @if (expanded()) {
          <span id="cus_logout" class="nav-list-text">Logout</span>
        }
      </div>
    </div>
  </mat-drawer>

  <div id="page_header" class="page-header">
    @for (crumb of crumbs(); track crumb.link; let i = $index) {
      <span id="{{ crumb.text }}" class="breadcrumbs">
        @if (crumbs().length !== i + 1) {
          <a [routerLink]="crumb.link">{{ crumb.text }}</a>
        }
        @if (crumbs().length === i + 1) {
          <span>{{ crumb.text }} </span>
        }
        @if (crumbs().length !== i + 1) {
          <span> / </span>
        }
      </span>
    }
  </div>
  <router-outlet></router-outlet>
</mat-drawer-container>
